/* eslint-disable */
import {ModalDispatch} from "../context/ModalContext";
import React, {useContext} from "react";
import FontSelector from "./FontSelector";
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import {ConfigContext} from "../context/ConfigContext";
import defaultData from '../data/defaultData.json';
import ConfigurationsService from "../services/ConfigurationsService";
import {SavedConfigurationsContext, SavedConfigurationsDispatch} from "../context/SavedConfigurationsContext";
import uuid from "draft-js/lib/uuid";
import {EditTypeContext, EditTypeDispatch} from "../context/EditTypeContext";
import {LoaderDispatch} from "../context/LoaderContext";
import PdfRenderer from "./PdfDocument";
import Price from "./Price";
import {AuthContext} from "../context/LoginContext";
import {PriceContext, buildPriceExport} from "../context/PriceContext";
import {
    resolveFinishAndColor,
    resolvePunctuationSizeErpId,
    resolveMounting,
    mountingRequiresInquiry,
} from "../services/erpMapping";
import {WorkingSizeContext} from "../context/WorkingSizeContext";
import {useLanguage} from "../context/LanguageContext";

export const AppNavigation = () => {
    const {t} = useLanguage();
    const priceContext = useContext(PriceContext);
    const loaderDispatch = useContext(LoaderDispatch);
    const editTypeContext = useContext(EditTypeContext);
    const editTypeDispatch = useContext(EditTypeDispatch);
    const modalDispatch = useContext(ModalDispatch);
    const textSectionsDispatch = useContext(TextSectionsDispatch);
    const textSections = useContext(TextSectionsListContext);
    const config = useContext(ConfigContext);
    const user = useContext(AuthContext);
    const savedConfigurationsContext = useContext(SavedConfigurationsContext);
    const savedConfigurationsDispatch = useContext(SavedConfigurationsDispatch);
    const workingSize = useContext(WorkingSizeContext)
    const [errorMsg, setErrorMsg] = React.useState('');
    const [successMsg, setSuccessMsg] = React.useState('');
    const [configurationName, setConfigurationName] = React.useState('');

    function clearMessages() {
        setErrorMsg('');
        setSuccessMsg('');
    }

    function deactivateAllTextSections() {
        return new Promise((resolve) => {
            textSectionsDispatch({
                type: 'deactivateAllTextSections'
            });
            textSectionsDispatch({
                type: "removeEmptyTextSections"
            });
            resolve();
        })
    }

    function exportData(fromCart = false) {
        let id = editTypeContext.id !== null ? editTypeContext.id : uuid();
        const data = {
            id: id,
            name: editTypeContext.name,
            fontConfig: config,
            textSections: textSections.map((section, index) => {
                return {
                    value: section.value,
                    position: section.position,
                    fontSize: section.fontSize,
                    letterSpacing: section.letterSpacing,
                    fontSizeValue: section.fontSizeValue,
                    index: index,
                    rawContent: section.rawContent,
                    textAlign: section.textAlign,
                    active: section.active,
                }
            }),
            erpData: getListDataForERP(),
            // Ten sam kształt, co w konfiguratorze na karcie produktu — sklep
            // czyta z niego cenę koszyka i zapisuje rozbicie per symbol w zamówieniu.
            price: buildPriceExport(priceContext),
            woocommerceProductId: config.selectedFontObject.woocommerce_product_id,
            workingSize: workingSize,
            fromCart: fromCart
        }
        //console.log('exportData', data);
        return data;
    }

    function resetTextSections() {
        const userConfirmed = confirm(
            t('toolbar.confirmFontChange')
        );

        if (!userConfirmed) {
            return;
        }

        return new Promise((resolve) => {
            textSectionsDispatch({
                type: 'resetTextSections'
            });
            editTypeDispatch({
                type: 'setType',
                payload: 'save'
            });
            editTypeDispatch({
                type: 'setName',
                payload: ''
            });
            resolve();
        });
    }

    function setAsEdit() {
        return new Promise((resolve) => {
            const id = uuid();
            editTypeDispatch({
                type: 'setId',
                payload: id
            });
            editTypeDispatch({
                type: 'setType',
                payload: 'edit'
            });
            editTypeDispatch({
                type: 'setName',
                payload: 'cart Item'
            });
            resolve();
        });
    }

    // Funkcja pomocnicza do wyszukiwania id_erp po name w fontsSizesList
    function getFontSizeErpIdByName(name) {
        const found = config.fontsSizesList.find(item => item.font_size.name === name);
        return found ? found.font_size.id_erp : null;
    }

    const getListDataForERP = () => {

        // Wykończenie i kolor mapowane tą samą funkcją, co żądanie wyceny — dzięki
        // temu przeliczenie zamówienia z erpData trafia w ten sam wiersz cennika.
        const {typeErpId, colorErpId} = resolveFinishAndColor(config);
        // Rozmiar interpunkcji dobiera serwer (cennik „Int." zależy od materiału).
        const punctuationSizeErpId = resolvePunctuationSizeErpId(priceContext);
        // Mocowanie efektywne (bolec / taśma) — to samo, które poszło do wyceny.
        const mountingOption = resolveMounting(config, textSections).option || config.selectedMountingObject;

        const result =
            {
                Tekst: textSections[0] ? textSections[0].rawContent : [],
                Czcionka: config.selectedFontObject.font[0].id_erp,
                Mocowanie: mountingOption?.id_erp ?? null,
                Material: config.selectedMaterialObject.id_erp,
                Wykonczenie: typeErpId,
                Kolor: colorErpId,
                KolorSlug: config.selectedColorObject?.slug || null,
                NapisyPozycje: textSections.map((section, index) => {
                    const name = section.fontSize;
                    // Szukamy id_erp na podstawie nazwy
                    const fontId = getFontSizeErpIdByName(name);
                    return {
                        Tekst: section.rawContent,
                        RozmiarLiter: fontId,
                        RozmiarInterpunkcji: punctuationSizeErpId,
                    };
                }),
            }

        return result;
    }

    async function saveNewConfiguration() {
        clearMessages();
        const service = new ConfigurationsService();
        const response = await service.createConfiguration(exportData());
        //console.log('saveNewConfiguration', response);

        if (response.status === 'success') {
            setSuccessMsg(t('actions.configSaved'));
        } else {
            setErrorMsg(t('actions.configSaveError'));
        }
    }

    async function refreshConfigurationLists() {
        const service = new ConfigurationsService();
        const response = await service.getConfigurations();
        //console.log('updateConfigurationLists', response);
        savedConfigurationsDispatch({
            type: 'set',
            payload: response
        });
    }

    async function handleAddConfiguration() {
        loaderDispatch({type: 'activate'});
        await saveNewConfiguration();
        await refreshConfigurationLists();
        loaderDispatch({type: 'deactivate'});
    }

    async function handleChangeConfiguration() {
        loaderDispatch({type: 'activate'});
        clearMessages();
        const service = new ConfigurationsService();
        const response = await service.editConfiguration(editTypeContext.id, exportData());
        //console.log('edit configuration ', response);

        if (response.status === 'success') {
            setSuccessMsg(t('actions.configSaved'));
        } else {
            setErrorMsg(t('actions.configSaveError'));
        }
        loaderDispatch({type: 'deactivate'});
    }

    // Mocowanie kierujące do indywidualnej wyceny (reguły ACF mounting_type produktu).
    const inquiryRequired = mountingRequiresInquiry(config, resolveMounting(config, textSections).key);

    // Do koszyka tylko z kompletną wyceną: bez wariantów spoza cennika, bez
    // mocowania „na zapytanie" i z ceną > 0.
    const canAddToCart = priceContext.allowAddToCart
        && !priceContext.isPriceLoading
        && !priceContext.unavailable
        && !inquiryRequired
        && priceContext.priceGross > 0;

    async function addToCart() {
        clearMessages();
        if (!canAddToCart) {
            if (inquiryRequired) {
                setErrorMsg(t('price.mountingInquiry'));
            } else {
                setErrorMsg(priceContext.unavailable ? t('price.unavailable') : t('common.error'));
            }
            return;
        }
        const data = exportData(true);
        const service = new ConfigurationsService();
        //zapisujemy konfigurację do koszyka dla niezalogowanych użytkowników
        const response = await service.createConfigurationForNotLoggedInUsers(data);
        //zapisujemy konfiguracje dla zalogowanych użytkowników, później ten konfigurację będzie można wczytać z aplikacji
        if (user.isLoggedIn) {
            await service.createConfiguration(data);
        }

        //save data to cookies, up to 1 month, we need this in cease if user want to edit cart item
        sessionStorage.setItem(`configurationData_${data.id}`, JSON.stringify(data));
        //console.log('saveNewConfiguration For not looged in users', response);

        if (response.status === 'success') {
            window.open(process.env.REACT_APP_WC_SITE_URL + 'koszyk?uuid=' + data.id, '_blank');
        } else {
            setErrorMsg(t('common.error'));
        }
    }

    function handleConfigurationNameChange(e) {
        setConfigurationName(e.target.value);
        editTypeDispatch({
            type: 'setName',
            payload: e.target.value
        })
    }

    return (
        <div className="nav-actions">
            <button
                onClick={addToCart}
                className="mt-4 btn btn--secondary"
                aria-label={t('actions.addToCart')}
                disabled={!canAddToCart}
                aria-disabled={!canAddToCart}
            >
                {t('actions.addToCart')}
            </button>
            <button
                className="btn"
                onClick={resetTextSections}
                type="button"
            >
                {t('actions.newTemplate')}
            </button>
            {user.isLoggedIn ?
                editTypeContext.type === 'save' ? (
                    <div style={{display: 'flex', gap: '2rem',}}>
                        <button
                            className={`btn${configurationName.length === 0 ? ' disabled' : ''}`}
                            onClick={handleAddConfiguration}
                            aria-disabled={configurationName.length === 0}
                            disabled={configurationName.length === 0}
                            type="button"
                        >
                            {t('actions.saveTemplate')}
                        </button>
                        <label htmlFor="configurationName" className="visually-hidden">{t('common.name')}</label>
                        <input
                            type="text"
                            id="configurationName"
                            value={configurationName}
                            onChange={handleConfigurationNameChange}
                            placeholder={t('actions.templateNamePlaceholder')}
                            aria-label={t('actions.templateNamePlaceholder')}
                        />
                    </div>
                ) : (
                    <div style={{display: 'flex', gap: '2rem',}}>
                        <button
                            className="btn"
                            onClick={handleChangeConfiguration}
                            type="button"
                        >
                            {t('actions.saveChanges')}
                        </button>
                        <label htmlFor="editConfigurationName" className="visually-hidden">{t('actions.templateName')}</label>
                        <input
                            type="text"
                            id="editConfigurationName"
                            disabled
                            value={editTypeContext.name}
                            aria-label={t('common.name')}
                        />
                    </div>
                )
                : <div className="nav-actions__info"
                       style={{marginTop: 'auto', color: '#333', background: '#fff', padding: '0.5rem'}}
                       aria-live="polite">
                    {t('actions.loginToSave')}
                </div>
            }
        </div>
    )
}
